<script>
import { getServiceDate } from '@/api'
export default {
  data() {
    return {
      resolve: () => {},
      reject: () => {}
    }
  },
  mounted() {
    getServiceDate().then(res => {
      if (Math.abs(+new Date(res.data.date) - new Date()) > 30 * 60 * 1000) {
        this.$confirm(
          '系统时间异常',
          `<p>平台检测到您的电脑系统时间与服务器时间不一致，为保证答题顺利进行，请更新校准您的系统时间（校准后时间生效可能会有延迟，请稍等片刻再点击继续按钮）</p><p class="tip2">提示：请在电脑系统时间设置中处理，可根据自己的电脑情况百度查询具体设置步骤。</p>`,
          {
            useHtml: true,
            confirmTxt: '已处理，继续',
            cancelTxt: '退出',
            class_rel: 'checkLocalTimeWrap',
            closeOnClickModal: false,
            showClose: false
          }
        )
          .then(() => {
            window.location.reload()
          })
          .catch(() => {
            window.history.back()
          })
      } else {
        this.resolve()
      }
    })
  }
}
</script>
<style lang="less">
.checkLocalTimeWrap {
  .isBack {
    width: 120px !important;
  }
  .content {
    width: 364px !important;
  }
  .desc {
    text-align: left !important;
  }
  .tip2 {
    margin-top: 10px;
    color: #999;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Stu/checkLocalTime/app.vue